import * as d3 from 'd3'
import structs from './structures'

var exports = {}

exports.hashCode = (str)=>{
    var hash = 0;
    if (str.length == 0) return hash;
    for (var i = 0; i < str.length; i++) {
        hash = ((hash<<5)-hash)+str.charCodeAt(i)
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}

exports.mode = (input,accessor)=>{
  var counts = {}
  input.forEach( (item)=>{
    var c = accessor(item)
    if (!(c in counts)) counts[c]=1
    else counts[c]++
  })
  var k = Object.keys(counts)
  k.sort( (a,b)=>{return counts[b]-counts[a]})
  return k[0]
}

exports.sum = (children, f)=>{
  return children.reduce( (prev, curr) => prev + curr[f], 0 );
}

exports.sum_callable = (children, f)=>{
  return children.reduce( (prev, curr) => prev + curr[f](), 0 );
}

exports.collect = (children, f)=>{
  return children.reduce( (a,b) => { a.push(b[f]); return a },[])
}

exports.flatten = (children, f)=>{
  return children.reduce( (a, b) => { return a.concat(b[f]) },[] )
}

exports.flatten_callable = (children, f)=>{
  return children.reduce( (a, b) => { return a.concat(b[f]()) },[] )
}

exports.flatten_exclusive = (children, f)=>{
  return exports.flatten(children,f).filter( (x,i,a) => a.indexOf(x) == i)
}

exports.flatten_exclusive_callable = (children, f)=>{
  return exports.flatten_callable(children,f).filter( (x,i,a) => a.indexOf(x) == i)
}


exports.move_node = (n,dst,storage_type)=>{
  n[storage_type+"_origin"]=n.parent
  dst.parent.children = [...dst.parent.children,n]
  n.parent.children.splice(n.parent.children.indexOf(n),1)
  n.parent=dst.parent
}

exports.revert_node = (n,storage_type)=>{
  n[storage_type+"_origin"].children = [...n[storage_type+"_origin"].children,n]
  n.parent.children.splice(n.parent.children.indexOf(n),1)
  n.parent=n[storage_type+"_origin"]
  delete n[storage_type+"_origin"]

}

exports.re_target = (l,n)=>{
  l.target.target_links = l.target.target_links.filter( item=> item!== l)
  l.target = n
  n.target_links.push(l)
}

exports.re_source = (l,n)=>{
  l.source.source_links = l.source.source_links.filter( item=> item!== l)
  l.source = n
  l.source_links.push(l)
}

exports.add_link = (links,n1,n2,val) =>{
  var id = exports.get_new_index(links)
  var l =new structs.Link(id,n1,n2,val,"",false)
  n1.source_links.push(l)
  n2.target_links.push(l)
  return l
}

exports.duplicate_node = (nodes,base_n,add_name) =>{
  var nid = exports.get_new_index(nodes)
  var new_n = new structs.Node()
  new_n.copyObject(base_n)
  new_n.index=nid
  new_n.name+=" ("+add_name+")"
  var new_cn = new structs.CompoundNode([new_n])
  new_n.parent = new_cn
	new_cn.index = nid
  var prev_par = base_n.parent
  new_cn.y_position = prev_par.y_position+1.
    return new_cn
}

var flow = (n,key,is_down)=>{
  var val = n[key]
  var front = []
  front = [...(is_down ? n.source_links : n.target_links)]
  var n_front = []
  var seen = {}
  while(front.length > 0){
    front.forEach((l)=>{
      var relevant_node = is_down ? l.target : l.source
      var opposite_node = is_down ? l.source : l.target
      var relevant_links = is_down ? relevant_node.source_links : relevant_node.target_links
      relevant_node[key]=val
      if(seen[relevant_node.index]!=1 && relevant_links.length > 0){
        n_front = n_front.concat(relevant_links)
      }
      seen[relevant_node.index]=1
    })
    front = [...n_front]
    n_front = []
  }
}

exports.flowUpstream = (n,key)=>{
  flow(n,key,false)
}

exports.flowDownstream = (n,key)=>{
  flow(n,key,true)
}

var upstream = (n,sl,sn)=>{
  sn[n.index]=1
  n.target_links.forEach((l)=>{
    sl[l.index]=1
    if(!(sn[l.source.index])){
      upstream(l.source,sl,sn)
    }
  })
}

var downstream = (n,sl,sn)=>{
  sn[n.index]=1
  n.source_links.forEach((l)=>{
    sl[l.index]=1
    if(!(sn[l.target.index])){
      downstream(l.target,sl,sn)
    }
  })
}

exports.upstream = upstream
exports.downstream = downstream

exports.get_new_index = (obj) =>{
  return d3.max(Object.keys(obj),(k)=>{return parseInt(k)}) + 1
}


export default exports



//////////////////
// WEBPACK FOOTER
// ./src/utils.js
// module id = null
// module chunks = 